// Utilitário para forçar limpeza completa de Service Workers e cache
// Use: window.clearAllCache() no console do navegador

export const clearAllCache = async () => {
  console.log('🧹 INICIANDO LIMPEZA COMPLETA...');

  // 1. Remover todos os Service Workers
  if ('serviceWorker' in navigator) {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations();
      console.log(`🗑️ Encontrados ${registrations.length} Service Workers`);

      for (const registration of registrations) {
        console.log('🗑️ Removendo SW:', registration.scope);
        const result = await registration.unregister();
        console.log(`${result ? '✅' : '❌'} SW removido:`, registration.scope);
      }
    } catch (error) {
      console.error('❌ Erro ao remover Service Workers:', error);
    }
  }

  // 2. Limpar todos os caches
  if ('caches' in window) {
    try {
      const cacheNames = await caches.keys();
      console.log(`🗑️ Encontrados ${cacheNames.length} caches`);

      for (const cacheName of cacheNames) {
        console.log('🗑️ Removendo cache:', cacheName);
        const result = await caches.delete(cacheName);
        console.log(`${result ? '✅' : '❌'} Cache removido:`, cacheName);
      }
    } catch (error) {
      console.error('❌ Erro ao limpar caches:', error);
    }
  }

  // 3. Limpar localStorage (exceto token para não deslogar)
  const preserveKeys = ['token', 'companyDueDate'];
  const keysToRemove = [];

  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (!preserveKeys.includes(key)) {
      keysToRemove.push(key);
    }
  }

  keysToRemove.forEach(key => {
    localStorage.removeItem(key);
    console.log('🗑️ Removido do localStorage:', key);
  });

  // 4. Limpar sessionStorage
  sessionStorage.clear();
  console.log('🗑️ sessionStorage limpo');

  // 5. Forçar reload da página
  console.log('🔄 Recarregando página em 2 segundos...');
  setTimeout(() => {
    window.location.reload(true);
  }, 2000);

  console.log('✅ LIMPEZA COMPLETA FINALIZADA!');

  return {
    serviceWorkersRemoved: 'serviceWorker' in navigator,
    cachesCleared: 'caches' in window,
    localStoragePartiallyCleared: true,
    sessionStorageCleared: true
  };
};

// Adicionar função global para uso no console
if (typeof window !== 'undefined') {
  window.clearAllCache = clearAllCache;

  // Auto-executar limpeza se estiver em aba anônima
  if (window.navigator && window.navigator.userAgent.includes('Chrome')) {
    // Detectar modo incógnito (aproximação)
    const fs = window.RequestFileSystem || window.webkitRequestFileSystem;
    if (fs) {
      fs(window.TEMPORARY, 100,
        () => {}, // Não é incógnito
        () => {   // É incógnito
          console.log('🕵️ Modo incógnito detectado - executando limpeza automática');
          clearAllCache();
        }
      );
    }
  }
}

export default clearAllCache;